import Store from "App/Store.js";

export default (Id, Expiry, Country) => Store.dispatch({type: "checkoutBasketIdentity", Id, Expiry, Country});
